import { Component, OnInit } from '@angular/core'
import { FormBuilder, FormGroup, Validators } from '@angular/forms'
import { ActivatedRoute, Router } from '@angular/router'
import { addDoc, collection, doc, docData, serverTimestamp, updateDoc } from '@angular/fire/firestore'
import * as firestore from 'firebase/firestore'
import { Faq, FaqCategory, faqsPath } from '@parkupp/core'
import { AdminService } from '../../../../services/admin.service'

@Component({
    selector: 'app-admin-faq-edit',
    templateUrl: './admin-faq-edit.component.html',
    styleUrls: ['./admin-faq-edit.component.scss'],
})
export class AdminFaqEditComponent implements OnInit {
    formGroup: FormGroup
    faqKey?: string
    faq: Faq | null = null
    loading = false
    saving = false
    error: string | null = null

    constructor(private formBuilder: FormBuilder, private adminService: AdminService, private route: ActivatedRoute, private router: Router) {
        this.formGroup = this.formBuilder.group({
            category: ['client' as FaqCategory, [Validators.required]],
            question: ['', [Validators.required]],
            answer: ['', [Validators.required]],
            order: [0, [Validators.required]],
            published: [true],
        })
    }

    ngOnInit(): void {
        this.faqKey = this.route.snapshot.params['faqKey']
        if (this.faqKey) {
            this.loadFaq()
        }
    }

    private loadFaq() {
        if (!this.faqKey) return
        this.loading = true
        docData(doc(this.adminService.firestore, faqsPath(), this.faqKey)).subscribe((data: any) => {
            if (!data) {
                this.error = 'FAQ not found'
                this.loading = false
                return
            }
            this.faq = new Faq(data)
            this.faq.$key = this.faqKey
            this.formGroup.patchValue({
                category: this.faq.category || 'client',
                question: this.faq.question || '',
                answer: this.faq.answer || '',
                order: this.faq.order ?? 0,
                published: this.faq.published ?? true,
            })
            this.loading = false
        })
    }

    async save() {
        if (this.formGroup.invalid) {
            this.formGroup.markAllAsTouched()
            return
        }
        this.saving = true
        this.error = null

        const value = this.formGroup.value
        const payload: any = {
            category: value.category,
            question: value.question,
            answer: value.answer,
            order: Number(value.order) || 0,
            published: !!value.published,
            updatedAt: serverTimestamp() as firestore.Timestamp,
        }

        try {
            if (this.faqKey) {
                await updateDoc(doc(this.adminService.firestore, faqsPath(), this.faqKey), payload)
            } else {
                payload.createdAt = serverTimestamp() as firestore.Timestamp
                await addDoc(collection(this.adminService.firestore, faqsPath()), payload)
            }
            this.router.navigate(['/admin/cms/faqs'])
        } catch (error: any) {
            this.error = error?.message || 'Failed to save FAQ'
            this.saving = false
        }
    }

    cancel() {
        this.router.navigate(['/admin/cms/faqs'])
    }
}
